import Vue from 'vue';
import VueRouter from 'vue-router';
import iview from 'iviewxx';
import Vuex from 'vuex';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import zhLocale from '@/components/locale/lang/zh-CN';
import enLocale from '@/components/locale/lang/en-US';
import twLocale from '@/components/locale/lang/zh-TW';
import store from '@/store/store';
import api from '@/api/api';
import '@/assets/http'; // 引入拦截器
import '@/assets/common';
import echarts from 'echarts';

// 路由配置，定义路由
import main from '@/components/layout/main';
import personalCenter from './components/logisticsProvider/personalCenter';
// 个人中心
import channelManagement from './components/logisticsProvider/channelManagement';
import parcelManagement from './components/logisticsProvider/parcelManagement';
import customerAnalysis from './components/logisticsProvider/customerAnalysis';
import customerManagement from './components/logisticsProvider/customerManagement';
import waybillNumber from './components/logisticsProvider/waybillNumber';
import pricingModelManagement from './components/logisticsProvider/pricingModelManagement';
import channelManagementOld from './components/logisticsProvider/channelManagement_old'; // 旧的渠道管理,已不使用
import warehouseInfo from './components/logisticsProvider/warehouseInfo';
import owChannelManagement from './components/logisticsProvider/owChannelManagement';
import accessStatistics from './components/logisticsProvider/accessStatistics';
Vue.prototype.$echarts = echarts;// 访问管理

Vue.prototype.axios = axios;
Vue.config.debug = true; // 开启debug模式
Vue.use(VueRouter); // 初始化自定义组件
Vue.use(VueI18n);
Vue.use(iview);
Vue.use(Vuex);
Vue.locale('zh-CN', zhLocale);
Vue.locale('en-US', enLocale);
Vue.locale('zh-TW', twLocale);
let lang = localStorage.getItem('lang');
if (lang != null) {
  Vue.config.lang = lang;
} else {
  const language = navigator.browserLanguage ? navigator.browserLanguage : navigator.language;
  Vue.config.lang = language;
  localStorage.setItem('lang', language);
}
// 引入路由组件
store.commit('inGroup', 'logisticsProvider'); // 需AJAX向server请求菜单
let pageName = getLastPageName();
store.commit('thisPage', pageName);
const routes = [{
  path: '/',
  component: main,
  redirect: '/personalCenter', // 引入主文件
  children: [{
    path: '/personalCenter',
    component: personalCenter
  },
  {
    path: '/channelManagement',
    component: channelManagement // 渠道管理
  },
  {
    path: '/parcelManagement',
    component: parcelManagement // 包裹管理
  },
  {
    path: '/customerAnalysis',
    component: customerAnalysis // 客户分析
  },
  {
    path: '/customerManagement',
    component: customerManagement // 客户管理
  },
  {
    path: '/waybillNumber',
    component: waybillNumber // 运单号管理
  },
  {
    path: '/pricingModelManagement',
    component: pricingModelManagement // 已经上线的计费模型[admin查看]-旧版本，已不使用
  },
  {
    path: '/channelManagementOld',
    component: channelManagementOld // 渠道管理-旧版本，已不使用
  },
  {
    path: '/warehouse',
    component: warehouseInfo // 海外仓仓库
  },
  {
    path: '/owchannelManagement',
    component: owChannelManagement // 海外仓渠道
  },
  {
    path: '/accessStatistics',
    component: accessStatistics // 访问管理
  }

  ]
}];
const router = new VueRouter({
  mode: 'hash',
  history: false,
  routes
});
// 全局导航钩子,token处理
router.beforeEach(function (to, from, next) {
  let url = window.location.href;
  // 浏览器回退前进点击时菜单状态改变
  let pathIndex = to.path.lastIndexOf('/');
  let pathName = to.path.slice(pathIndex + 1, to.path.length);
  // let menuKey = pathName + '_query' === '_query' ? 'personalCenter_query' : pathName + '_query';
  if (pathName !== store.state.thisPage) {
    store.commit('clickStatus', true);
    store.commit('thisPage', pathName);
  } else {
    store.commit('clickStatus', false);
  }
  // ticket判断
  if (to.fullPath.indexOf('ticket') > 0) {
    let ticket = getQueryString('ticket');
    if (ticket !== sessionStorage.getItem('ticket')) {
      sessionStorage.setItem('ticket', ticket);
      axios.get(api.get_token + ticket)
        .then(function (response) {
          sessionStorage.setItem('token', response.data.datas.token);
          var date = new Date().getTime();
          sessionStorage.setItem('refreshTime', date);
          setTimeout(refreshToken, api.token_time);
          next();
        });
    } else {
      setTimeout(function () {
        window.location.href = url.split('?ticket')[0];
      }, 1000);
      next();
    }
  } else {
    if (sessionStorage.getItem('token') !== null) {
      var date = new Date().getTime();
      axios.get(api.refresh_token + sessionStorage.getItem('token'))
        .then(function (response) {
          sessionStorage.setItem('refreshTime', date);
          setTimeout(refreshToken, api.token_time);
        });
    }
    next();
  }
});

// function loadInitData () {
//   if (store.state.erpConfig) {
//     return new Promise(resolve => {
//       resolve(true);
//     });
//   }
//   return new Promise(resolve => {
//     axios.get(api.get_erpConfig)
//       .then(function (response) {
//         if (response.data.code === 0) {
//           store.commit('erpConfig', response.data.datas);
//           resolve(true);
//         }
//       });
//   });
// }

// function getUserMes () {
//   var userInfoList = store.state.userInfoList;
//   if (userInfoList.length === 0) {
//     axios.get(api.get_userInfo)
//       .then(response => {
//         if (response.data.code === 0) {
//           if (response.data.datas !== null) store.commit('userInfoList', response.data.datas);
//           debugger;
//         }
//       });
//   }
// }

function refreshToken () { // 重新获取token
  let date = new Date().getTime();
  let sessionTime = sessionStorage.getItem('refreshTime');
  let diffTime = date - Number(sessionTime);
  if (diffTime > api.token_time) {
    axios.get(api.refresh_token + sessionStorage.getItem('token'))
      .then(function (response) {
        sessionStorage.setItem('refreshTime', date);
        setTimeout(refreshToken, api.token_time);
      })
      .catch(function (err) {
        console.log(err);
      });
  } else {
    setTimeout(refreshToken, diffTime);
  }
}

function getQueryString (name) { // 获取url里面的参数
  let reg = new RegExp('(^|&?)' + name + '=([^&]*)(&|$)', 'i');
  let r = window.location.href.substr(1).match(reg);
  if (r !== null) { return unescape(r[2]); } else { return null; }
}

function getLastPageName () {
  let url = window.location.href;
  let l;
  if (url.indexOf('?') > 0) {
    url = url.split('?')[0].split('/');
    l = url.length;
  } else {
    url = url.split('/');
    l = url.length;
  }
  return url[l - 1];
}

// 创建实例挂载到#app
new Vue({
  router,
  store // 引入store配置
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/views/logisticsProvider/logisicsProvider.js